import { isFilled } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";

const richTextBase = {
  strong: ({ children }) => <strong className="md">{children}</strong>,
  em: ({ children }) => <em>{children}</em>,
  hyperlink: ({ children, node }) => (
    <a href={node.data.url} className="underline underline-offset-2">
      {children}
    </a>
  ),
};

const titleComponents = {
  ...richTextBase,
  heading3: ({ children }) => <h3 className="p-lg-n sbd text-bleu">{children}</h3>,
  heading4: ({ children }) => <h3 className="p-lg-n sbd text-bleu">{children}</h3>,
};

const textComponents = {
  ...richTextBase,
  paragraph: ({ children }) => (
    <p className="p-lg-n text-bleu not-last:mb-5">{children}</p>
  ),
};

/**
 * Card with an illustration, a title and a text.
 * @param {{ item: { picture: import("@prismicio/client").ImageField, title: import("@prismicio/client").RichTextField, text: import("@prismicio/client").RichTextField } }} props
 */
const KeyPoint = ({ item }) => (
  <div className="flex flex-col items-center gap-10 rounded-[10px] bg-beige-50 px-[30px] py-10 lg:flex-row lg:gap-[30px]">
    {isFilled.image(item.picture) && (
      <div className="flex w-[100px] shrink-0 items-center">
        <PrismicNextImage
          field={item.picture}
          fallbackAlt=""
          className="h-auto w-full object-contain"
          sizes="100px"
        />
      </div>
    )}
    <div className="flex w-full min-w-0 flex-1 flex-col gap-4">
      {isFilled.richText(item.title) && (
        <PrismicRichText field={item.title} components={titleComponents} />
      )}
      {isFilled.richText(item.text) && (
        <PrismicRichText field={item.text} components={textComponents} />
      )}
    </div>
  </div>
);

export default KeyPoint;
